import React from 'react';

import { RefinementListPanelProps } from '@white-nl/instantsearch-components/dist/types/components';
import { CollapsiblePanel } from '@white-nl/instantsearch-components';
import RefinementList from '../RefinementList/RefinementList';

export default function RefinementListPanel({
  results,
  refinementList,
  refinementListSettings,
  additionalData,
}: RefinementListPanelProps) {
  const { canRefine } = refinementList;

  const { panelSettings } = refinementListSettings;

  if (panelSettings?.hideIfEmpty && !canRefine) {
    return null;
  }

  return (
    <CollapsiblePanel
      collapsiblePanelSettings={panelSettings?.collapsiblePanelSettings}
      header={panelSettings?.header}
      footer={panelSettings?.footer}
    >
      <RefinementList
        results={results}
        refinementList={refinementList}
        refinementListSettings={refinementListSettings}
        additionalData={additionalData}
      />
    </CollapsiblePanel>
  );
}
